(function ($) {
    $(function () {




        if ($("#errorModal1").length) {
            $("#errorModal1").iziModal();
        }

        if ($("#errorModal2").length) {

            $("#errorModal2").iziModal();
        }

        if ($("#errorModal3").length) {
            $("#errorModal3").iziModal();
        }

        if ($("#acceptCookieModal").length) {
            $("#acceptCookieModal").iziModal();
        }




        var selDiv = $('#uploader');
        var storedFiles = [];
        function handleFileSelect(e) {
            var files = e.target.files;
            var filesArr = Array.prototype.slice.call(files);
            filesArr.forEach(function (f) {
                if (storedFiles.length >= 5) {
                    $("#errorModal1").iziModal('open');
                    return;
                }

                if (f.size / 1024 / 1024 > 5) {
                    $("#errorModal2").iziModal('open');
                    return;
                }


                var fileReader = new FileReader();
                fileReader.onloadend = function (e) {
                    var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
                    var header = '';
                    for (var i = 0; i < arr.length; i++) {
                        header += arr[i].toString(16);
                    }

                    var type = 'unknown';
                    switch (header) {
                        case '89504e47':
                            type = 'image/png';
                            break;
                        case '47494638':
                            type = 'image/gif';
                            break;
                        case 'ffd8ffe0':
                        case 'ffd8ffe1':
                        case 'ffd8ffe2':
                        case 'ffd8ffee':
                        case 'ffd8ffdb':
                            type = 'image/jpeg';
                            break;
                        case '25504446':
                            type = 'application/pdf';
                            break;
                    }

                    if (f.type !== type) {
                        $("#errorModal3").iziModal('open');
                        return;
                    } else {
                        storedFiles.push(f);

                        var reader = new FileReader();

                        reader.onloadstart = function () {
                            selDiv.addClass('loading');
                        };

                        reader.onloadend = function () {
                            selDiv.removeClass('loading');
                        };

                        reader.onload = function (e) {
                            var html = "<div  class=\"uploaded__files\"><img class=\"ofi-cover-center\" src=\"".concat(e.target.result, "\" ><span class=\"remove__file\" data-file=\"").concat(f.name, "\"></span></div>");
                            selDiv.prepend(html);

                        }
                        reader.readAsDataURL(f);
                        $('#files')[0].files = new FileListItem(storedFiles)
                    }
                };
                fileReader.readAsArrayBuffer(f);

            });

            selDiv.addClass('active');

        }


        function FileListItem(a) {
            a = [].slice.call(Array.isArray(a) ? a : arguments)
            for (var c, b = c = a.length, d = !0; b-- && d;) d = a[b] instanceof File
            if (!d) throw new TypeError("expected argument to FileList is File or array of File objects")
            for (b = (new ClipboardEvent("")).clipboardData || new DataTransfer; c--;) b.items.add(a[c])
            return b.files
        }

        function removeFile(e) {
            var file = $(this).data("file");
            for (var i = 0; i < storedFiles.length; i++) {
                if (storedFiles[i].name === file) {
                    storedFiles.splice(i, 1);
                    break;
                }
            }
            $('#files')[0].files = new FileListItem(storedFiles)
            if (storedFiles.length < 1) {
                selDiv.removeClass('active');
            }
            $(this).parent().remove();
        }
        if (document.getElementById('files') != null) {
            document.getElementById('files').addEventListener('change', handleFileSelect, false);
        }


        $("body").on("click", ".remove__file", removeFile);

        $('#accept1').on('change', function (e) {
            e.preventDefault();
            $(this).closest('.form__item').removeClass('has--error');
        })

        $('#accept2').on('change', function (e) {
            e.preventDefault();
            $(this).closest('.form__item').removeClass('has--error');
        })

        var hasLetterRegex = "[a-zA-ZÀ-ÖØ-öø-ÿ-]";
        function removeLetters(string) {
            var r = new RegExp(hasLetterRegex, "g");
            return string.replace(r, "");
        }

        function formatPhoneNumber(string) {
            return removeLetters(string).replace(" ", "");
        }

        $(document).on("keypress keyup blur", ".js-input-phone", function () {
            this.value = formatPhoneNumber(this.value);
        });

        $(document).on('keydown', 'input', function (e) {
            $(this).prev().removeClass('message--error');
        });

        $(document).on('change', 'input[type="checkbox"]', function (e) {
            $(this).removeClass('message--error')
        });

        window.devisGratuitFormSubmit = function () {
            if (grecaptcha.getResponse() !== "") {
                $("#main-form").submit();
              }
            grecaptcha.reset();
        };

        window.presentationFormSubmit = function () {
            if (grecaptcha.getResponse() !== "") {
                $("#presentation-form").submit();
              }
            grecaptcha.reset();
        };

        var submitted = false;

        //Submit main (Devis Gratuit) form 
        $("#main-form").on('submit', function (e) {
            e.preventDefault();

            var theForm = $(this);

            var formData = new FormData();

            var params = $(this).serializeArray();
            Object.keys(params).forEach(key => {
                formData.append(params[key].name, params[key].value);
            })


            jQuery.each($('#main-form').find('input[type=file]')[0].files, function (i, file) {
                formData.append('file-' + i, file);
            });

            if(submitted == true){
                return;
            }

            submitted = true;

            $('.loader').css("opacity", "1");
            $('.js-submit-form').addClass('disabled');

            $.ajax({
                url: localize.ajaxurl + '?action=contact_form',
                type: "POST",
                processData: false,
                contentType: false,
                context: this,
                dataType: "json",
                data: formData,
                error: function (response) {
                    console.log(response);
                },
                success: function (datas) {

                    var result = datas;
                    var fields = [...new Set(result['fields'])];

                    if (result['status'] == 'success') {
                        theForm.trigger("reset");
                        window.location.href = localize.devis_gratuit_form_success_url;
                    } else {
                        $('.loader').css("opacity", "0");
                        submitted = false;
                        $(fields).each(function (i, e) {
                            theForm.find(`[name='${e}']`).closest('.form__item').addClass('has--error');
                        });
                        
                        if ($('.has--error').length) {
                            
                            $('html, body').animate({
                                scrollTop: $('.has--error').first().parent().offset().top - $('header').height() - 25
                            }, 1000);
                        }
                        $('.js-submit-form').removeClass('disabled');
                    }
                    

                },
            });
        });

        function isCaptchaChecked() {
            return grecaptcha && grecaptcha.getResponse().length !== 0;
        }

        //Submit presentation form 
        $('#presentation-form').on('submit', function (e) {
            e.preventDefault();

            var alertShown = false;
            $('#presentation-form input.required').each(function (i, el) {
                if (el.value == '') {

                    alertShown = true;
                    $(this).parent().addClass('has--error')

                }
            });

            if ($('#typedesoins').val() == null) {
                alertShown = true;
                $('#typedesoins').parents('.select__wrapper').addClass('has--error')
            }


            if (alertShown) {
                e.preventDefault();
            } else {
                $('.js-submit-wrapper').addClass('active');
            }

            e.preventDefault()

            var $this = $(this);

            var formData = new FormData();

            var params = $(this).serializeArray();
            Object.keys(params).forEach(key => {
                formData.append(params[key].name, params[key].value);
            })

            formData.append('action', 'contact_form_presentation');

            jQuery.each($this.find('input[type=file]')[0].files, function (i, file) {
                formData.append('file-' + i, file);
            });


            $.ajax({
                url: localize.ajaxurl,
                type: "POST",
                data: formData,
                contentType: false,
                processData: false,
                context: this,
                dataType: "json",
                error: function (response) {
                    console.log(response);
                },
                success: function (datas) {

                    var result = datas;
                    var fields = [...new Set(result['fields'])];

                    if (result['status'] == 'success') {
                        $this.trigger("reset");

                        var url = location.href.replace('/form/', '/form-success');
                        window.location.href = url;
                    } else {
                        $(fields).each(function (i, e) {
                            $this.find(`[name='${e}']`).closest('.form__item').addClass('has--error');
                        });

                        if ($('.has--error').length) {

                            $('html, body').animate({
                                scrollTop: $('.has--error').first().parent().offset().top - $('header').height() - 25
                            }, 1000);
                        }
                    }
                },
            });
        })


        $('#showAcceptCookieModal').on('click', function (e) {
            if ($('#acceptCookie').val() === "0") {
                e.preventDefault();
                $("#acceptCookieModal").iziModal('open');
            }
        });


        $(document).on("click", ".js-accept-form-cookies", function () {
            $('#chk-error').addClass('hide');
            if ($('#accept').is(':checked')) {
                $('#acceptCookie').val(1);
                $("#acceptCookieModal").iziModal('close');
                $('#showAcceptCookieModal').click();
            } else {
                $('#chk-error').removeClass('hide');
            }
        })




    });
})(jQuery);